export default {
  currentRoute(state) {
    return state.route;
  },
  lastRoute(state) {
    return state.lastRoute;
  }
};
